import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import { ColorNames } from '../../constants';
import { formatEnum } from '../../utils/formatters';
import Text from '../elementals/text';
import InfoPill from '../elementals/infoPill';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const getMilestoneStatus = (offerWorkflowStatus, code) => {
    const formattedStatus = formatEnum(offerWorkflowStatus);
    const mappings = {
        CLOSING_SCHEDULED: (_jsx(InfoPill, { content: formattedStatus, backgroundColor: ColorNames.CautionLight, foregroundColor: ColorNames.Caution, includeBorder: true, className: cx('milestone-closing-status') })),
    };
    return mappings[code] || null;
};
const MilestoneLabel = ({ milestone, offerWorkflowStatus, elmId = 'milestone_label', }) => {
    return (_jsxs("div", { className: cx('milestone-label'), children: [_jsx(Text, { size: 'small', weight: 'heavy', className: cx('milestone-title'), children: milestone?.label }), getMilestoneStatus(offerWorkflowStatus, milestone?.code)] }, `${elmId}_${milestone?.code}`));
};
export default MilestoneLabel;
//# sourceMappingURL=MilestoneLabel.js.map